import CryptoJS from 'crypto-js';

export default {
  generatekey(num) {
    let library = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let key = "";
    for (var i = 0; i < num; i++) {
      let randomPoz = Math.floor(Math.random() * library.length);
      key += library.substring(randomPoz, randomPoz + 1);
    }
    return key;
  },
  aesEncrypt(str, key) {
    let _key = key || '5F6B2AK33DASD1235E74C231B47AC8F6'
    const __key = CryptoJS.enc.Utf8.parse(_key) //将秘钥转换成Utf8字节数组
    //加密
    const encrypt = CryptoJS.AES.encrypt(JSON.stringify(str), __key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return encrypt.toString()
  },
  aesDecrypt(str, key) {
    let _key = key || '5F6B2AK33DASD1235E74C231B47AC8F6'
    const __key = CryptoJS.enc.Utf8.parse(_key) //将秘钥转换成Utf8字节数组
    const decrypt = CryptoJS.AES.decrypt(str, __key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    const _decrypt = JSON.parse(decrypt.toString(CryptoJS.enc.Utf8)) //解密后的数据
    return _decrypt
  }
}




// WEBPACK FOOTER //
// ./src/utils/crypto.js